import { useCallback, useEffect, useState } from 'react';
import { useApiGet } from '@sierralabs/core-ui';
export function useGetEntities() {
    const { data, isLoading, error, get } = useApiGet('entities');
    const [entities, setEntities] = useState(data);
    useEffect(() => void (data && setEntities(data)), [data]);
    const getEntities = useCallback((validate, includeDeleted) => {
        get({
            validate: validate !== null && validate !== void 0 ? validate : false,
            includeDeleted: includeDeleted !== null && includeDeleted !== void 0 ? includeDeleted : false
        });
    }, [get]);
    return {
        entities,
        loadingEntities: isLoading,
        loadingEntitiesError: error,
        getEntities,
        setEntities
    };
}
//# sourceMappingURL=useGetEntities.js.map